import { useTranslate } from "ra-core";

import {
  Deliveries,
  MyTasks,
  NextDays,
} from "@/components/fretum/dashboard/HubWidgets";

import { AttentionInbox } from "./AttentionInbox";
import { CollectCard } from "./CollectCard";
import { QuickActions } from "./QuickActions";
import { TodayAgenda } from "./TodayAgenda";
import { TodayCounters } from "./TodayCounters";
import { useHomeToday } from "./useHomeData";

/**
 * View A «Hoy» (desktop): what needs doing today and the tools to do it.
 * Counters → attention inbox | agenda, receivables, quick actions → the hub
 * widgets that used to hide under «More».
 */
export const HomeToday = () => {
  const translate = useTranslate();
  const { inbox, counters, collect, deals, isPending, hasInvoices } =
    useHomeToday();

  return (
    <div className="home-a">
      <TodayCounters counters={counters} collect={collect} />
      <div className="home-a__main">
        <AttentionInbox
          inbox={inbox}
          counters={counters}
          deals={deals}
          isPending={isPending}
        />
        <aside className="home-a__side">
          <TodayAgenda />
          {hasInvoices ? <CollectCard collect={collect} /> : null}
          <QuickActions />
        </aside>
      </div>
      <section className="home-a__more" aria-labelledby="home-more-title">
        <h2 id="home-more-title" className="home-section-title">
          {translate("desk.home.more_title")}
        </h2>
        <div className="home-a__hub">
          <MyTasks />
          <Deliveries />
          <NextDays />
        </div>
      </section>
    </div>
  );
};
